import { IonButton, IonCol, IonRow } from '@ionic/react';
import ReactDataSheet, { DataEditor } from 'react-datasheet';
import 'react-datasheet/lib/react-datasheet.css';

import { getValue } from 'helpers/events';

const measurementsFromLoad = (load, depthIncrement) => {
  const minPileRows = (load.pileOptions.pileLength + 5) / depthIncrement;
  const rows = _.max([minPileRows, 10]);
  return _.times(rows, (i) => [(i + 1) * depthIncrement]);
};

const withHeaders = (values) => [
  [
    {value: "Depth", readOnly: true, width: "60px"},
    {value: "Torque (ft‑lbs)", readOnly: true},
    {value: "Pressure (psi)", readOnly: true},
    {value: "Annotation", readOnly: true, width: "170px"}
  ],
  ...values
];

const hydrate = (measurements) => withHeaders(_.map(measurements, (row) => [
  {value: row[0], className: 'depth-cell', readOnly: true},
  {value: row[1] || '', className: 'number-cell'},
  {value: row[2] || '', className: 'number-cell'},
  {value: row[3] || '', className: 'annotation-cell'},
]));

const ANNOTATIONS = [
  'Augering',
  'Practical Refusal',
  'Obstruction',
  'Working Pile Up and Down',
  'Retorque Measurement',
]

const AnnotationDropdown = ({onChange, value}) => {
  return (
    <select name="annotation" onChange={getValue(onChange)} value={value}>
      <option></option>
      {ANNOTATIONS.map((annotation) => <option key={annotation}>{annotation}</option>)}
    </select>
  );
}

export default function HelicalMeasurements({load, depthIncrement, measurements, onChange}) {
  const data = measurements || measurementsFromLoad(load, depthIncrement);

  const addRow = () => {
    const lastDepth = _.last(data)[0];
    onChange([...data, [lastDepth + depthIncrement]]);
  };
  const removeRow = () => {
    onChange(_.slice(data, 0, data.length - 1));
  };

  return <>
    <ReactDataSheet
      data={hydrate(data)}
      valueRenderer={(cell) => cell.value}
      dataEditor={(props) => (
        props.cell.className === 'annotation-cell' ? (
          <AnnotationDropdown {...props} />
         ) : <DataEditor {...props} />
      )}
      onCellsChanged={(changes) => {
        const newMeasurements = _.cloneDeep(data);
        changes.forEach(({row, col, value}) => {
          newMeasurements[row - 1][col] = value;
        });
        onChange(newMeasurements);
      }}
      className="log-table"
    />
    <IonRow>
      <IonCol>
        <IonButton onClick={addRow} color="tertiary" size="small" expand="block">
          + Add Row
        </IonButton>
      </IonCol>
      <IonCol>
        <IonButton onClick={removeRow} color="warning" size="small" expand="block">
          - Remove Row
        </IonButton>
      </IonCol>
    </IonRow>
  </>;
}
